var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items.length > 0
    ? _c(
        "div",
        { staticClass: "md-chips md-primary md-theme-default" },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "md-chip md-theme-default" },
            [_vm._v("\n        " + _vm._s(item) + "\n    ")]
          )
        }),
        0
      )
    : _c("div", [_vm._v("\n    " + _vm._s(_vm.noneLabel) + "\n")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }